import { ProgressSpinner } from "primereact/progressspinner";

export default function SplashScreen({message}: { message?: string }) {

    return (
        <div className="flex flex-column justify-content-center gap-3">
            <ProgressSpinner strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" className="flex align-items-center justify-content-center" />
            <div>
                <div className="flex align-items-center justify-content-center text-2xl font-bold">
                    {message}
                </div>
            </div>
        </div>
    );
}